import * as Sentry from '@sentry/react'

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
const environment = import.meta.env.MODE
const isDev = environment === 'development'

// Sentry silently no-ops when DSN is absent or empty.
// In development, only init if VITE_SENTRY_DSN is explicitly set — local
// errors should not consume quota.
const shouldInit = !!dsn && (!isDev || import.meta.env.VITE_SENTRY_FORCE_DEV === 'true')

if (shouldInit) {
  Sentry.init({
    dsn,
    environment,
    maxBreadcrumbs: 50,
    sampleRate: 1.0,
    tracesSampleRate: 0.1,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.inboundFiltersIntegration({
        ignoreErrors: [
          // Browser extension noise
          /^Script error\.?$/,
          /^Non-Error promise rejection captured/,
          // ResizeObserver — fires on every layout shift, never actionable
          /ResizeObserver loop/,
        ],
        denyUrls: [
          // Chrome extensions
          /extensions\//i,
          /^chrome:\/\//i,
          /^chrome-extension:\/\//i,
          /^moz-extension:\/\//i,
        ],
      }),
    ],

    // Do NOT enable console integration — 150+ console.error paths would
    // exhaust the free-tier quota immediately.
    // Do NOT enable session replay — GDPR implications for screens showing
    // tenant personal data. Decide separately.
  })
}

export { Sentry }
